import React from "react";
import { Spinner } from 'components'
const AuthButton = ({
  type = "submit",
  disabled = false,
  onClick,
  variant,
  loading,
  submitingText,
  children
}) => {
  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={`w-full justify-center rounded-md ${
        variant !== "outlined"
          ? disabled
            ? "bg-[#d4f9f9] text-[#36d2da] py-3 dark:text-[#1a7684] dark:bg-[#0e353e] cursor-not-allowed"
            : "text-white bg-[#1996A6] py-3 dark:bg-[#1a7684] dark:hover:bg-[#1996a6] hover:bg-[#1ab5c0]"
          : "bg-[#FFFFFF] border-[#D9D9D9] border-2 text-black "
      }`}
    >
      <div className="relative w-full flex justify-center">
        {loading ? (
          <div className="flex  items-center gap-2">
            <Spinner color={"#1996a6"} />
            <span>{submitingText}</span>
          </div>
        ) : (
          <>{children}</>
        )}
      </div>
    </button>
  );
};

export default AuthButton;
